import '@odo/shared-ui/clinical-pdf/pdfPolyfill';
import { pdf } from '@react-pdf/renderer';
import { DxReportDocument } from './DxReportDocument';
import type { DxReportPayload } from './types';

/**
 * Render the Dx report payload to a PDF Blob. The PDF is built entirely
 * client-side via React-PDF, then handed to the backend as multipart so
 * the same PDF the doctor previewed is the one stored in GCS — no
 * server-side rendering divergence.
 */
async function generateDxReportPdf(payload: DxReportPayload): Promise<Blob> {
    return pdf(<DxReportDocument payload={payload} />).toBlob();
}

export { generateDxReportPdf };
